<h2 mat-dialog-title>Mensaje</h2>
<mat-dialog-content class="mat-typography">
<p>{{data}}</p>
<button mat-raised-button mat-dialog-close color="primary">Cerrar</button>
</mat-dialog-content>

